module.exports = __webpack_public_path__ + "img/BhWallet.be87f2c4.png";